export default __webpack_public_path__ + "static/media/dev.7e9602e4.svg";